'use client';

import { useEffect, useState } from 'react';
import { Checkbox, CheckboxChangeEvent } from 'primereact/checkbox';
import { SolidFormWidgetProps } from '@solidstarters/solid-core-ui';
import { Message } from 'primereact/message';

const RequiredCheckboxWidget = ({
  formData,
  field,
  fieldsMetadata,
  viewMetadata,
}: SolidFormWidgetProps) => {
  const fieldName = field.attrs.name;
  const [checked, setChecked] = useState<boolean>(formData?.[fieldName] === 'true');
  const [error, setError] = useState<string | null>(null);

    console.log("formData is", formData);
  const handleChange = (event: CheckboxChangeEvent) => {
    
    const isChecked = event.checked ?? false;
    // formik.setFieldValue('bondTncConfirmed', isChecked)
    setChecked(isChecked);
    formData[fieldName] = isChecked ? 'true' : '';
    if (isChecked) {
      setError(null);
      if (formData.errors) {
        delete formData.errors[fieldName];
      }
    } else {
      const errorMessage = `${field.attrs.label || fieldName} is required`;
      setError(errorMessage);
      if (!formData.errors) {
        formData.errors = {};
      }
      formData.errors[fieldName] = errorMessage;
    }
  };

  useEffect(() => {
    // Ensure field exists in formData on mount
    formData[fieldName] = checked ? 'true' : '';

    // Set initial error if not checked
    if (!checked) {
      const errorMessage = `${field.attrs.label || fieldName} is required`;
      setError(errorMessage);
      if (!formData.errors) {
        formData.errors = {};
      }
      formData.errors[fieldName] = errorMessage;
    }
  }, []);

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <Checkbox
          id={fieldName}
          checked={checked}
          onChange={handleChange}
        />
        <label htmlFor={fieldName}>
          {field.attrs.label || 'Accept Terms'}
        </label>
        <span className="text-red-500"> *</span>
      </div>
      {error && <span className="text-red-500 text-sm">{error}</span>}
      {error && (
        <div className="absolute mt-1">
          <Message severity="error" text={error} />
        </div>
      )}
    </div>
  );
};

export default RequiredCheckboxWidget;
